<template>
  <div class="checkItemWrapper" v-bind:style="style.flex">
    <img class="checkButton" v-bind:src="checkBoxImg" v-on:click="onCheckButton">
    <span>{{text}}</span>
  </div>
</template>

<script>

export default {
  props: {
    type: String,
    itemKey: [String, Number],
    text: String,
    flexRatio: Number
  },
  data () {
    return {
      checkBoxImg: '',
      isSelected: false,
      style: {
        flex: 'flex-grow: 0; flex-shrink: 0; flex-basis: calc(' + 100 / this.flexRatio + '% - 15px);'
      }
    }
  },
  methods: {
    onCheckButton: function () {
      if(this.isSelected) {
        this.$store.commit('removeEnrollStateValue', {type: this.type, value: this.itemKey})
      }else{
        if(this.itemKey === -1) {
          // 모두 를 선택했을 시
          this.$store.commit('setEnrollStateArr', {type: this.type, value: [-1]})
        }else {
          // 모두 가 아닌 값을 선택 했을 시
          let beforeValue = this.$store.getters.getEnrollStateValue(this.type)
          beforeValue.push(this.itemKey)
          let formattedValue = beforeValue.filter(items => items !== -1)
          this.$store.commit('setEnrollStateArr', {type: this.type, value: formattedValue})
        }
      }
    }
  },
  created: function () {
    if(this.$store.getters.getEnrollStateValue(this.type).includes(this.itemKey)) {
      this.checkBoxImg = require('@/assets/img/checkbox_selected_img.png')
      this.isSelected = true
    }else{
      this.checkBoxImg = require('@/assets/img/checkbox_not_selected_img.png')
      this.isSelected = false
    }
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getEnrollStateValue(this.type), value => {
      if(value.includes(this.itemKey)) {
        this.checkBoxImg = require('@/assets/img/checkbox_selected_img.png')
        this.isSelected = true
      }else {
        this.checkBoxImg = require('@/assets/img/checkbox_not_selected_img.png')
        this.isSelected = false
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.checkItemWrapper {
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  padding-right: 15px;
  padding-bottom: 10px;
}

.checkItemWrapper > span {
  margin-left: 5px;
  font-size: 13px;
}

.checkButton{
  cursor: pointer;
  width: 32px;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/checkItemDuplicate.vue